"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Steps = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("./utils");
require("./steps.css");
;
/**
 * Main component.
 * @name steps
 * @param {StepsProps}
 * @returns {<Steps />}
*/
const Steps = ({ stepsList = [], title = "" }) => {
    return (react_1.default.createElement("div", { className: "steps-container" },
        react_1.default.createElement("div", { className: "steps-title" },
            react_1.default.createElement("span", { "data-testid": "steps-title-element" }, title)),
        react_1.default.createElement("div", { className: "steps-box-container", "data-testid": "steps-element" }, (0, utils_1.renderSteps)(stepsList))));
};
exports.Steps = Steps;
//# sourceMappingURL=steps.js.map